import { useEffect, useState } from "react";
import "./Main.css";
import Footer from "./Footer/Footer";
import Header from "./Home/Header";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const Project = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const { t } = useTranslation();


  const staticSite = [
    "/assets/s1.webp",
    "/assets/s2.webp",
    "/assets/s3.webp",
    "/assets/s4.webp",
    "/assets/s5.webp",
    "/assets/s6.webp",
  ];

  const ecom = [
    "/assets/e1.webp",
    "/assets/e2.webp",
    "/assets/e3.webp",
    "/assets/e4.webp",
  ];

  const product = [
    "/assets/p1.webp",
    "/assets/p2.webp",
    "/assets/p3.webp",
    "/assets/p4.webp",
    "/assets/p5.webp",
    "/assets/p6.webp",
  ];

  const mobile = ["/assets/m1.webp", "/assets/m2.webp", "/assets/m3.webp"];
  const [data,setData]=useState<any>(staticSite)
  const [activeIndex, setActiveIndex] = useState(0);
 const handleClick = (index:any, siteData:any) => {
    setData([...siteData]);
    setActiveIndex(index);
  };

  return (
    <>
      <Helmet>
        <title>A Showcase of Our Finest Projects</title>
        <meta
          name="description"
          content="Discover our showcased projects, where innovation meets excellence. Explore our portfolio of digital triumphs and see what sets us apart."
        />
      </Helmet>
      <Header />
      <section className="page-banner-area Projectbanner pt-245 rpt-150 pb-170 rpb-100 rel z-1 bgc-lighter text-center">
        <div className="container">
          <div className="banner-inner rpt-10">
            <h1 className="page-title wow fadeInUp delay-0-2s">
              {t("projBannerH")}
            </h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-center wow fadeInUp delay-0-4s">
                <li className="breadcrumb-item">
                  <Link to="/">
                    {t("projBannerHome")}
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#fff" }}
                >
                  {t("projBannerHomeNav")}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
         <div className="d-flex justify-content-center align-items-center">
      <div className="proj-div">
        <ul>
          <li
            onClick={() => handleClick(0, staticSite)}
            className={activeIndex === 0 ? "activeP" : "nonActiveP"}
          >
            Static Websites
          </li>
          <li
            onClick={() => handleClick(1, ecom)}
            className={activeIndex === 1 ? "activeP" : "nonActiveP"}
          >
            E-com Websites
          </li>
          <li
            onClick={() => handleClick(2, product)}
            className={activeIndex === 2 ? "activeP" : "nonActiveP"}
          >
            Products
          </li>
          <li
            onClick={() => handleClick(3, mobile)}
            className={activeIndex === 3 ? "activeP" : "nonActiveP"}
          >
            Mobile Apps
          </li>
        </ul>
      </div>
    </div>
          <div className="row py-3 justify-content-start">
            {data.map((val:any) => (
              <div className="col-lg-4 col-md-4 col-sm-12 col-12 p-0">
                <div className="p-2">
                  <img
                    className="img-fluid"
                    alt="img"
                    loading="lazy"
                    src={val}
                  />
                </div>
              </div>
            ))}
          </div>
          <p className="pb-3 text-end" style={{color:"#E572C5"}}>{activeIndex===0?"50":activeIndex===1?"30":activeIndex===2?"8":"3"}+ Products More</p>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Project;
